<template>
  <div v-on:mouseover="onMouseOver" v-on:mouseout="onMouseOut" :class="componentClasses">
    <slot :isMouseOver="isMouseOver" />
  </div>
</template>

<script>
/*
  MouseEventContainer

  this component was created to coordinate mouse-over events for a number of children components
*/
export default {

  data() {
    return {
      isMouseOver: false,
    };
  },

  computed: {

    componentClasses() {
      // console.warn(`mouseOver status: ${this.isMouseOver}`);
      const classes = {
        'hover--active': this.isMouseOver,
      };
      return classes;
    },

  },

  methods: {

    onMouseOver() {
      this.isMouseOver = true;
    },

    onMouseOut() {
      this.isMouseOver = false;
    },

  },

};
</script>



// WEBPACK FOOTER //
// src/components/MouseEventContainer.vue